import { CommonService } from "../../../../../services/CommonService";
import NumberOfDependants from "../../components/NumberOfDependants";
import { order } from "../SmartSearchParammeter";

export default async function NumberDependantsSearchConfig(key) {
  let numberDependants = await CommonService.getNumberOfDependats();
  
  return {
    description: "Nº of dependants",
    id: "numberOfDependantId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <NumberOfDependants searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact"],
    list: numberDependants.map((m) => m.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["numberOfDependantId"] = numberDependants
        .filter((m) => value[0] == m.description.replace(/#/g, ",").trim())
        .map((m) => m.id)
        .shift();
    }
  };
}
